import {GetAccessInformationResults} from "@/types/scorm";
import { $axios, apiList } from '@/api'

export default {
    state: () => ({
        scormAccessInfo: null,
        scormId: null,
        scormContext: null,
        scormInfo: null,
        scormAttemptCount: null,
        scormScoes: [],
        scormShowScoes: false,
        scormSelectedScoe: null,
        scormScoesLoading: false,
    }),

    mutations: {
        /**
         * @param state
         * @param {GetAccessInformationResults} payload
         */
        setAccessInfo(state, payload) {
            state.scormAccessInfo = payload;
        },
        /**
         * @param state
         * @param {number} payload
         */
        setScormId(state, payload) {
            state.scormId = payload;
        },
        /**
         * @param state
         * @param {number} payload
         */
        setScormContext(state, payload) {
            state.scormContext = payload;
        },
        /**
         * @param state
         * @param {number} payload
         */
        setScormInfo(state, payload) {
            state.scormInfo = payload;
        },
        setAttemptCount(state, payload) {
            state.scormAttemptCount = payload;
        },
        setScormScoes(state, payload) {
            state.scormScoes = payload;
        },
        showScoes(state) {
            state.scormShowScoes = true;
        },
        hideScoes(state) {
            state.scormShowScoes = false;
        },
        setSelectedScoe(state, payload) {
            state.scormSelectedScoe = payload;
        },
        setScormScoesLoading(state, payload) {
            state.scormScoesLoading = payload;
        }
    },

    actions: {
        /**
         * @param commit
         * @param
         * @param {number} id
         */
        setScormId({commit}, id) {
            commit('setScormId', id);
        },
        /**
         * @param commit
         * @param
         * @param {number} id
         */
        setScormContextId({commit}, id) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.tool.getContextid.method,
                    params: {
                        wsfunction: apiList.tool.getContextid.moodle_method,
                        mode: 'mod',
                        id: id,
                    }
                })
                    .then(resp => {
                        if (!resp.data.errorcode) {
                            commit("setScormContext", resp.data.contextid);
                        } else {
                            reject(resp.data)
                        }
                    }).catch(err => reject(err))
            })
        },
        //eslint-disable-next-line
        /**
         *
         * @param state
         * @param commit
         * @return {Promise<GetAccessInformationResults>}
         */
        loadAccessInfo({state, commit}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.scorm.getAccessInformation.method,
                    params: {
                        wsfunction: apiList.scorm.getAccessInformation.moodle_method,
                        scormid: state.scormId
                    }
                })
                    .then(resp => {
                        if (!resp.data.errorcode) {
                            const result = new GetAccessInformationResults(resp.data)
                            resolve(result)
                            commit("setAccessInfo", result);
                        } else {
                            reject(resp.data)
                        }
                    }).catch(err => reject(err))
            })
        },
        //eslint-disable-next-line
        /**
         *
         * @param state
         * @param commit
         * @param courseId
         * @return {Promise<GetAccessInformationResults>}
         */
        loadScormInfo({state, commit}, courseId) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.scorm.getScormsByCourses.method,
                    params: {
                        wsfunction: apiList.scorm.getScormsByCourses.moodle_method,
                        'courseids': [courseId]

                    }
                })
                    .then(resp => {
                        if (!resp.data.errorcode) {
                            const result = resp.data.scorms.filter(scorm => scorm.id === state.scormId);

                            resolve(result[0] || null);
                            commit("setScormInfo", result[0] || null);
                        } else {
                            reject(resp.data)
                        }
                    }).catch(err => reject(err))
            })
        },
        //eslint-disable-next-line
        /**
         *
         * @param state
         * @param commit
         * @param courseId
         * @return {Promise<GetAccessInformationResults>}
         */
        loadScormAttemptCount({state, commit, rootGetters}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.scorm.getAttemptCount.method,
                    params: {
                        wsfunction: apiList.scorm.getAttemptCount.moodle_method,
                        scormid: state.scormId,
                        userid: rootGetters.user.id,
                    }
                })
                    .then(resp => {
                        if (!resp.data.errorcode) {
                            const result = resp.data.attemptscount;

                            resolve(result || null);
                            commit("setAttemptCount", result || null);
                        } else {
                            reject(resp.data)
                        }
                    }).catch(err => reject(err))
            })
        },
        //eslint-disable-next-line
        /**
         *
         * @param state
         * @param commit
         * @param courseId
         * @return {Promise<GetAccessInformationResults>}
         */
        loadScormScoes({state, commit}) {
            commit('setScormScoesLoading', true)
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.scorm.getScoes.method,
                    params: {
                        wsfunction: apiList.scorm.getScoes.moodle_method,
                        scormid: state.scormId,
                    }
                })
                    .then(resp => {
                        if (!resp.data.errorcode) {
                            const result = resp.data.scoes;

                            resolve(result || []);
                            commit("setScormScoes", result || []);
                        } else {
                            reject(resp.data)
                        }
                        commit('setScormScoesLoading', false)
                    }).catch(err => reject(err))
            })
        },
        showScoes({dispatch, commit, state}) {
            dispatch('loadScormScoes')
            commit('showScoes')
            commit('setSelectedScoe', state.scormInfo.launch)
        },
        setScormScoe({commit}, payload) {
            commit('setSelectedScoe', payload)
        },
        scormHideScoes({commit}) {
            commit('hideScoes')
        },
        unMountScorm({commit}) {
            commit('hideScoes')
            commit('setSelectedScoe', null)
            commit('setAttemptCount', null)
            commit('setScormInfo', null)
            commit('setScormId', null)
            commit('setAccessInfo', null)
            commit('setScormScoes', [])
        }
    },

    getters: {
        /**
         * @param state
         * @return {null|GetAccessInformationResults}
         */
        scormAccessInfo: state => {
            return state.scormAccessInfo
        },        /**
         * @param state
         * @return {null|GetAccessInformationResults}
         */
        scormInfo: state => {
            return state.scormInfo
        },
        scormAttemptCount: state => {
            return state.scormAttemptCount
        },
        scormScoes: state => {
            return state.scormScoes.filter(scoe => scoe.parent !== '/').sort((a, b) => a.sortorder - b.sortorder)
        },
        scormRootScoe: state => {
            return state.scormScoes.filter(scoe => scoe.parent === '/')[0]
        },
        scormIsShowScoes: state => {
            return state.scormShowScoes;
        },
        scormSelectedScoe: state => {
            return state.scormSelectedScoe;
        },
        scormScoesLoading: state => {
            return state.scormScoesLoading;
        },
        scormScoeLaunch: (state, getters, rootState, rootGetters) => {
            return `${import.meta.env.VITE_APP_BASE_API_URL}webservice/pluginfile.php/${state.scormContext}/mod_scorm/content/0/${state.scormScoes.filter(scorm => scorm.id === state.scormSelectedScoe)[0].launch}`;
        }
    }
}
